import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import('@/views/FrHome.vue'),
  //   meta: {
  //     title: 'FR-eBay'
  //   }
  // },
  {
    path: '/',
    // path: '/head',
    name: 'header',
    component: () => import('@/components/FrHead.vue'),
  },
  // {
  //   path: '/',
  //   // path: '/body',
  //   name: 'body',
  //   // redirect: "/home",
  //   component: () => import('@/components/FrBody.vue'),
  // },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  // base: '/FR/fr-head/',//基础路径,要写服务器的路径
  routes
})

export default router
